import { render } from "./Devoluciones.vue?vue&type=template&id=7233765a&scoped=true"
import script from "./Devoluciones.vue?vue&type=script&lang=js"
export * from "./Devoluciones.vue?vue&type=script&lang=js"

import "./Devoluciones.vue?vue&type=style&index=0&id=7233765a&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7233765a"]])

export default __exports__